
import Vue from 'vue'

export default Vue.extend({
  // name: 'PunktBlock',
  props: {
    blocks: {
      type: Array,
      default: () => []
    }
  }
})
